(function () {
    'use strict';

    angular
        .module('app.accountManagement')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['authentication', '$state', '$stateParams', 'config'];

    function RegisterController(authentication, $state, $stateParams, config) {
        var vm = this;

        vm.isLoading = false;

        vm.onSubmit = onSubmit;
        vm.logIn = logIn;
        vm.passwordRequirements = null;

        activate();

        function activate() {
            // Redirect to dashboard if already logged in.
            if (authentication.isLoggedIn()) {
                $state.go('accountManagement.dashboard');
            }

            config.get().then(function (configData) {
                vm.passwordRequirements = configData.passwordRequirements;
                vm.trainingNote = configData.isTrainingWebsite ?
                    "Do not enter personal data on this training site except a real, accessible email here." : "";
            });
        }

        function onSubmit(email, password) {
            vm.isLoading = true;

            vm.formError = "";

            var params = {
                email: email,
                password: password
            };
            authentication.register(params)
                .then(function () {
                    $state.go('accountManagement.registrationLanding', $stateParams);
                    vm.isLoading = false;
                })
                .catch(function (error) {
                    vm.formError = error;
                    vm.isLoading = false;
                });
        }

        function logIn() {
            $state.go('accountManagement.logIn');
        }
    }
})();
